module.exports = __webpack_public_path__ + "static/media/video.d365509d.mp4";